/**
 * module-1.bottom.js
 *
 * Javascript for Module#1
 *
 * @package Wordpress/imhof-digital
 * @since 20200102 Version 5.0.4
 * @author Imhof Digital <info@imhof-digital.de>
 * @deprecated 5.6.0
 */

jQuery( document ).ready( function( $ ) {
  // declare strict mode
  'use strict';

   if( $( '#module-1' )[0] ) {
      /**
       * idscript.module_1
       *
       * @var     object  scrollButton      Scroll-Button element
       * @var     integer scrollTarget      Calculated lower edge
       * @method  void    bindClickHandler  Bind click handler to scroll-button
       * @method  void    bindResizeHandler Bind resize handler to window for recalculate scrollTarget
       * @method  void    scroll            Scrolls to the position of scrollTarget
       * @method  void    init              Initiate module#1 Object
       */
      idscript.module_1 = {
         scrollButton: $( '#module-1 .arrow-down' ),
         scrollTarget: $( '#module-1' )[0].offsetTop + $( '#module-1' )[0].offsetHeight,
         bindClickHandler: function() {
         $( idscript.module_1.scrollButton ).on( 'click', idscript.module_1.scroll );
         return;
         },
         bindResizeHandler: function() {
         $( window ).on( 'resize', function() {
           idscript.module_1.scrollTarget = $( '#module-1' )[0].offsetTop + $( '#module-1' )[0].offsetHeight;
           return;
         } );
         },
         scroll: function() {
         $( 'html, body' ).stop().animate({
           'scrollTop': idscript.module_1.scrollTarget
         }, 1000, 'swing');
         return;
         },
         init: function() {
            idscript.module_1.bindClickHandler();
            idscript.module_1.bindResizeHandler();
         return;
         }
     };
     idscript.module_1.init();
   }
} );
